import "./Footer.css";

export default function Footer() {
  return (
    <footer className="admin-footer">
      <span>© 2026 NX Optics. All Rights Reserved</span>
      <span>
        Designed &amp; Hosted By{" "}
        <a
          href="https://webuniversals.com"
          target="_blank"
          rel="noreferrer"
        >
          Web Universals
        </a>
      </span>
    </footer>
  );
}
